var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWsteth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "#00A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M16.9224 11.1475L17.0568 11.3536C18.5721 13.6781 18.2336 16.7223 16.2431 18.6726C15.0721 19.82 13.5374 20.3937 12.0026 20.3939C12.0026 20.3939 12.0026 20.3939 16.9224 11.1475Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.0021 13.9577L16.9219 11.1475C12.0021 20.3939 12.0021 20.3939 12.0021 20.3939C12.0021 18.3801 12.0021 16.0725 12.0021 13.9577Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07757 11.1475L6.94322 11.3536C5.42794 13.6781 5.76638 16.7223 7.75688 18.6726C8.92786 19.82 10.4626 20.3937 11.9974 20.3939C11.9974 20.3939 11.9974 20.3939 7.07757 11.1475Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.996 13.9577L7.07617 11.1475C11.996 20.3939 11.996 20.3939 11.996 20.3939C11.996 18.3801 11.996 16.0725 11.996 13.9577Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.0039 7.67969V12.5266L16.2418 10.1047L12.0039 7.67969Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M12.0026 7.67969L7.76172 10.1046L12.0026 12.5266V7.67969Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0026 3.60352L7.76172 10.1062L12.0026 7.67447V3.60352Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M12.0039 7.67372L16.245 10.1055L12.0039 3.59961V7.67372Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsteth);
export default __webpack_public_path__ + "static/media/WSTETH.8a5cb89bf6c072bd45c5ff791357b638.svg";
export { ForwardRef as ReactComponent };